import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-hero-event]', container).each((i, event) => {
    const $event = $(event);
    $event.find('[data-event-item]')
      .addClass('RteHeroEvent__item')
      .wrapAll('<div class="RteHeroEvent__items"></div>');

    $event.find('.RteHeroEvent__items').wrap('<div class="RteHeroEvent__items-container"></div>');
    $event.find('.RteHeroEvent__items-container').wrap('<div class="RteHeroEvent__items-wrapper"></div>');
    $event.wrap(`
      <section class="Section Section--fixed Section--mobile-full AnimateOnLoad Animate--slide-up">
        <div class="Section__container">
        </div>
      </section>
    `);

    $event.find('h1, h2').replaceWith(function() {
      // only using 'function' to have access to 'this' - shrug
      return `<h3>${$(this).text()}</h3>`;
    });
    
    const img_src = $event.data('imgSrc');

    if (img_src) {
      const event_html = $event.html();
      $event.html(`<img class="RteHeroEvent__image" onload="elementLoaded(this);" src="${img_src}">${event_html}`);
    }

    // get the outerHTML, including the changes we've made outside the DOM
    $event.addClass('RteHeroEvent');
  });
};